<template>
    <v-dialog v-model="isOpen" :width="dialogWidth">
        <template v-slot:activator="{ on }">
            <div class="d-flex flex-column align-center cursor-pointer">
                <span
                    class="font-weight-medium grey--text text--darken-2 mb-2"
                    style="font-size: 14px"
                >
                    {{ media.title }}
                </span>
                <img
                    ref="img"
                    @load="onImageLoaded"
                    :src="mediaUrl"
                    class="rounded"
                    style="width: 100%; aspect-ratio: 16 / 9;  object-fit: cover;"
                    v-on="on"
                />
                <div v-if="media.description" class="fade-text">
                    <p style="font-size: 14px">
                        {{ media.description }}
                    </p>
                </div>
            </div>
        </template>

        <v-card class="d-flex flex-column align-center">
            <img
                :src="mediaUrl"
                style="max-width: 100%; max-height: 700px;"
                :aspect-ratio="16 / 9"
            />

            <v-card-text class="pt-4">
                <h2 class="d-flex align-center">
                    {{ media.title }}
                </h2>

                <small>
                    {{ media.date | toDayMonthYearDate() }}
                </small>

                <v-divider class="my-2" />

                <div v-html="media.description" class="actuality-content ql-editor"></div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import documentsMixin from '../../mixins/documents';

export default {
    name: 'ProgressOnSite',

    mixins: [documentsMixin],

    props: {
        media: { type: Object, required: true }
    },

    data: () => ({
        isOpen: false,
        dialogWidth: 'auto'
    }),

    computed: {
        mediaUrl() {
            if (this.media.url) {
                return this.media.url;
            } else {
                return this.getMediaUrl(this.media.id);
            }
        }
    },

    methods: {
        onImageLoaded() {
            this.$nextTick(() => {
                const originalWidth = this.$refs.img.naturalWidth;
                const originalHeight = this.$refs.img.naturalHeight;
                const maxHeight = 700;

                let displayWidth;

                // If the image is taller than the max, scale it down:
                if (originalHeight > maxHeight) {
                    const scale = maxHeight / originalHeight;
                    displayWidth = Math.round(originalWidth * scale);
                } else {
                    // Otherwise, keep original dimensions
                    displayWidth = originalWidth;
                }

                this.dialogWidth = `${displayWidth}px`;
            });
        }
    }
};
</script>

<style scoped>
.fade-text {
  position: relative;
  max-height: 3em; /* Assuming ~1.5em per line, adjust as needed */
  overflow: hidden;
}

.fade-text p {
  margin: 0;
  display: -webkit-box;
  line-clamp: 2; /* Show only 2 lines */
  -webkit-line-clamp: 2; /* Show only 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fade-text::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1em;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
}
</style>